export const widgetViewPage = () =>
  import("./WidgetViewPage").then((m) => ({ Component: m.WidgetViewPage }));
